<template>
  <p><span v-html="value"></span></p>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      Type: String,
      default: '',
    },
    width: {
      required: false,
      type: String,
      default: 'uk-width-1-1',
    },
  },
}
</script>
